import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'
import { ReactComponent as Icon } from '../svgs/J2_Setup.svg'

const J2Setup: React.VFC<SvgIconProps> = props => <SvgIcon viewBox={'0 0 24 24'} component={Icon} {...props} fill="currentColor" />
export default J2Setup
